import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://znexmkbpfxerezvzykzr.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpuZXhta2JwZnhlcmV6dnp5a3pyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ2OTIzNjcsImV4cCI6MjA5MDI2ODM2N30.zEmXGWe21tl5gPQh4tGvOLPVBSmg5KHMAJMVdSCfwR4";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
  }
});